import React, { createContext, useState } from 'react';

export const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState([]);
  const [orderSummary, setOrderSummary] = useState(null);

  // Function to add an item to the cart
  const addToCart = (item) => {
    setCart(prevCart => {
      // Check if an item with the same name and option already exists in the cart
      const existingItem = prevCart.find(cartItem => 
        cartItem.name === item.name && cartItem.option === item.option
      );
      
      if (existingItem) {
        // Update the quantity if the item already exists in the cart
        return prevCart.map(cartItem =>
          cartItem.name === item.name && cartItem.option === item.option
            ? { ...cartItem, quantity: cartItem.quantity + item.quantity }
            : cartItem
        );
      } else {
        // Add the new item to the cart
        return [...prevCart, item];
      }
    });
  };

  // Function to remove an item from the cart (taking itemId and option into account)
  const removeFromCart = (itemName, option) => {
    setCart(prevCart => prevCart.filter(item => (item.name === itemName && item.option=== option)));
  };

  // Function to increase the quantity of an item in the cart
  const increaseQuantity = (itemName) => {
    setCart(prevCart =>
      prevCart.map(item =>
        item.name === itemName ? { ...item, quantity: item.quantity + 1 } : item
      )
    );
  };

  // Function to decrease the quantity of an item in the cart
  const decreaseQuantity = (itemName) => {
    setCart(prevCart =>
      prevCart.map(item =>
        item.name === itemName
          ? { ...item, quantity: item.quantity > 1 ? item.quantity - 1 : 1 }
          : item
      )
    );
  };

  // Function to handle placing the order
  const placeOrder = (customerName) => {
    const totalAmount = cart.reduce((acc, item) => acc + item.price * item.quantity, 0); // Calculate total
    const orderDate = new Date().toLocaleDateString(); // Get order date
    setOrderSummary({
      customerName,
      orderDate,
      items: cart,  // Store all cart items
      totalAmount   // Store total amount
    });
    setCart([]); // Clear the cart after placing the order
  };

  return (
    <CartContext.Provider
      value={{
        cart,
        addToCart,
        removeFromCart,
        increaseQuantity,
        decreaseQuantity,
        placeOrder,
        orderSummary
      }}
    >
      {children}
    </CartContext.Provider>
  );
};
